import React, { FC } from 'react';
import moment from 'moment';
import { Box, Typography } from '@material-ui/core';
import useStyles from './styles';
import { Compaigns_compaigns_compaigns } from '../../../graphql/compaign/types/Compaigns';

interface ICompaignItem {
  active?: boolean;
  item: Compaigns_compaigns_compaigns;
  onPress?: (event: any) => void;
}

const CompaignItem: FC<ICompaignItem> = (props) => {
  const { active, item, onPress } = props;

  const classes = useStyles();

  return (
    <Box
      boxShadow={1}
      className={[classes.wrapper, active && classes.wrapperActive].join(' ')}
      onClick={(event) => {
        onPress && onPress(event);
      }}>
      <Box className={classes.header}>
        <Typography noWrap className={classes.title}>
          {item?.title}
        </Typography>
        <Typography noWrap className={classes.subtitle}>
          {item?.message?.content?.text}
        </Typography>
      </Box>
      <Box className={classes.adornment}>
        <Box>
          <Typography className={classes.time}>
            {moment(item?.createdAt).calendar({
              sameDay: 'hh:mm',
              lastDay: '[Hier]',
              lastWeek: 'Do MMM',
              sameElse: 'Do MMM',
            })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CompaignItem;
